const FALLBACK_BASE_PATH = '/DeepResearchAIUI';

const isNonEmpty = (value?: string | null): value is string =>
  value !== undefined && value !== null && value !== '';

/**
 * Resolves the base path the app is served under so design-system assets line up
 * with the host app.
 *
 * Precedence mirrors the terminal app's runtime config (see app.config.ts):
 *   1. window.__RUNTIME_CONFIG__.APP_BASE_PATH – injected at container runtime
 *   2. process.env.APP_BASE_PATH              – baked in at build time
 *   3. the hard-coded default                 – local/dev + storybook fallback
 *
 * Returned without a trailing slash so it can be concatenated with absolute
 * asset paths (e.g. `${getBasePath()}/static/images/...`).
 */
export const getBasePath = (): string => {
  const runtimeBasePath = (
    globalThis as {
      __RUNTIME_CONFIG__?: { APP_BASE_PATH?: string };
    }
  ).__RUNTIME_CONFIG__?.APP_BASE_PATH;

  const buildTimeBasePath =
    typeof process !== 'undefined' && process.env
      ? process.env.APP_BASE_PATH
      : undefined;

  if (isNonEmpty(runtimeBasePath)) {
    return runtimeBasePath;
  }

  if (isNonEmpty(buildTimeBasePath)) {
    return buildTimeBasePath;
  }

  return FALLBACK_BASE_PATH;
};
